import { createFileRoute } from '@tanstack/react-router'

import { validateListSearch } from '#/shared/lib/list-search'

import { UsersPage } from '#/modules/users/users-page'

export const Route = createFileRoute('/_shell/users/')({
  component: UsersPage,
  validateSearch: validateListSearch,
})
